export const state = () => ({
	references: [],
	reference: null,
	experience_references: [],
	experience_reference: null,
	adding_reference: false,
});

export const mutations = {
	setReferences(state: any, payload: any) {
		state.references = payload;
	},
	setReference(state: any, payload: any) {
		state.reference = payload;
	},
	setAddingReference(state: any, payload: any) {
		state.adding_reference = payload;
	},
	setExperienceReferences(state: any, payload: any) {
		state.experience_references = payload;
	},
	setExperienceReference(state: any, payload: any) {
		state.experience_reference = payload;
	},
};

export const getters = {
	getReferences: (state: any) => state.references,
	getReference: (state: any) => state.reference,
	getAddingReference: (state: any) => state.adding_reference,
	getExperienceReferences: (state: any) => state.experience_references,
	getExperienceReference: (state: any) => state.experience_reference,
};

export const actions = {
	async getGeneralReferences(state: any, payload: any) {
		if (!(state.state.references.length > 0)) {
			return new Promise((resolve, reject) => {
				this.$axios
					.get('/api/profile/references')
					.then((res) => {
						state.commit('setReferences', res.data);
						resolve(res);
					})
					.catch((err) => {
						reject(err);
					});
			});
		} else {
			return new Promise((resolve, reject) => {
				resolve(state.state.references);
			});
		}
	},

	async getExperienceReferences(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.get('/api/profile/work-experiences/' + payload + '/references')
				.then((res) => {
					state.commit('setExperienceReferences', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async storeGeneralReference(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/references', payload)
				.then((res) => {
					state.commit('setReference', res.data);
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async storeExperienceReference(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					'/api/profile/work-experiences/' +
						payload.uuid +
						'/references',
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editReference(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.put('/api/profile/references/' + payload.uuid, payload.data)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteReference(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/references/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async storeReferenceDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post(
					'/api/profile/references/' + payload.uuid + '/documents',
					payload.data,
				)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async editReferenceDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.post('/api/profile/documents/' + payload.uuid, payload.data)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	async deleteReferenceDocument(state: any, payload: any) {
		return new Promise((resolve, reject) => {
			this.$axios
				.delete('/api/profile/documents/' + payload)
				.then((res) => {
					resolve(res);
				})
				.catch((err) => {
					reject(err);
				});
		});
	},

	addToReferences(state: any, payload: any) {
		let newReferences = JSON.parse(JSON.stringify(state.state.references));
		newReferences.push(payload);
		state.commit('setReferences', newReferences);
	},

	updateReferences(state: any, payload: any) {
		state.commit('setReferences', payload);
	},

	updateReference(state: any, payload: any) {
		state.commit('setReference', payload);
	},

	updateAddingReference(state: any, payload: any) {
		state.commit('setAddingReference', payload);
	},

	updateExperienceReferences(state: any, payload: any) {
		state.commit('setExperienceReferences', payload);
	},

	updateExperienceReference(state: any, payload: any) {
		state.commit('setExperienceReference', payload);
	},
};
